/**
 * 🛡️ 관리자 설정 (웹)
 *
 * ⚠️ 여기의 ADMIN_EMAILS는 "UI 노출용"일 뿐이다.
 * 실제 권한 검증은 서버 측에서 이루어진다:
 *   - functions/index.js 의 ADMIN_EMAILS (Cloud Functions)
 *   - firestore.rules 의 isAdmin()
 * 관리자를 추가/삭제할 때는 세 곳을 모두 함께 수정할 것.
 */

export const ADMIN_EMAILS = [
  'heekyoungryu@gmail.com',
];

/** 주어진 이메일이 관리자 이메일인지 확인 (대소문자 무시) */
export const isAdminEmail = (email?: string | null): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.trim().toLowerCase());
};
